import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isAndroid } from 'react-device-detect';

import { forms as Forms } from '@breezeway/brzw-components';

import './form_control_native_select.scss';
import ModalSelect from '../../../modal_select';

class FormControlNativeSelect extends React.PureComponent {
  constructor(props) {
    super(props);

    this.nativeSelect = React.createRef();

    this.state = {
      openModal: false,
    };

    this.changeNativeSelect = this.changeNativeSelect.bind(this);
    this.changeValueType = this.changeValueType.bind(this);
    this.focusNativeSelect = this.focusNativeSelect.bind(this);
    this.onModalSelect = this.onModalSelect.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  onModalSelect({ value }) {
    const {
      input: { onChange },
    } = this.props;
    onChange(value);
  }

  changeValueType(value) {
    const { options } = this.props;
    const firstOption = _.get(_.first(options), 'value');
    const firstOptionType = typeof firstOption;
    const changeTypeFunction = _.get(_, [`to${_.upperFirst(firstOptionType)}`]);
    if (changeTypeFunction) {
      return changeTypeFunction(value);
    }
    return value;
  }

  changeNativeSelect(e) {
    const {
      input: { onChange },
    } = this.props;

    if (e.target.value) onChange(this.changeValueType(e.target.value));
  }

  toggleModal() {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
    }));
  }

  focusNativeSelect() {
    this.nativeSelect.current.focus();
  }

  render() {
    const {
      input: { value },
      meta: { error },
      className,
      id,
      label,
      options,
      placeholder,
      required,
    } = this.props;

    const optionsWithDefault = [{ value: null, label: '-' }, ...options];

    return (
      <Fragment>
        <div role="presentation" onClick={isAndroid ? this.toggleModal : this.focusNativeSelect}>
          <Forms.Select
            key={`select-${value}`}
            className={className}
            id={id}
            isRequired={required}
            labelText={label}
            options={options}
            placeholderText={placeholder}
            value={value}
            withError={error}
            shouldOpenModal
            withNativeSelect
          />
        </div>
        {!isAndroid && (
          <select
            className="form-control-native-select__select"
            ref={this.nativeSelect}
            onChange={this.changeNativeSelect}
            defaultValue={value}
          >
            {_.map(optionsWithDefault, (option, index) => (
              <option key={option.value + index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
        {this.state.openModal && (
          <ModalSelect
            full
            onClose={this.toggleModal}
            onSelect={this.onModalSelect}
            options={options}
            title={label}
          />
        )}
      </Fragment>
    );
  }
}

FormControlNativeSelect.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

FormControlNativeSelect.defaultProps = {
  className: '',
  options: [],
};

export default FormControlNativeSelect;
